import script from "./KIconPicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./KIconPicker.vue?vue&type=script&setup=true&lang=ts"

import "./KIconPicker.vue?vue&type=style&index=0&id=a95daa50&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a95daa50"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCard});
